import { motion } from "framer-motion";

const TherapyClinicCaseStudy = () => {
  return (
    <section className="min-h-screen bg-[#050816] text-gray-300 px-6 py-24">
      <div className="max-w-5xl mx-auto">

        {/* Project Title */}
        <motion.div
          initial={{opacity:0, y:40}}
          animate={{opacity:1, y:0}}
          transition={{duration:0.6}}
        >
          <p className="text-purple-400 mb-2">Healthcare Automation</p>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Therapy Clinic Management System
          </h1>

          <p className="text-gray-400 text-lg max-w-3xl">
            A custom web-based management platform built for a therapy
            clinic to manage patients, therapists, bookings, payments,
            and session scheduling efficiently.
          </p>
        </motion.div>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-3 mt-6 mb-12">
          {["Next.js", "Node.js", "MongoDB", "Razorpay", "REST APIs"].map((tech)=>(
            <span
              key={tech}
              className="px-3 py-1 bg-white/5 border border-white/10 rounded-md text-sm"
            >
              {tech}
            </span>
          ))}
        </div>

        {/* Problem */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">Problem</h2>

          <p className="text-gray-400 leading-relaxed">
            The clinic was managing patient records, therapist schedules,
            and bookings using handwritten registers and Excel sheets.
            This process was time-consuming and made it difficult to track
            therapist availability, manage appointments, and compare
            therapist earnings with clinic revenue.
          </p>
        </div>

        {/* Solution */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">Solution</h2>

          <p className="text-gray-400 leading-relaxed">
            I developed a web-based management system that digitizes the
            entire clinic workflow including patient management, therapist
            scheduling, appointment booking, and payment processing.
            The system ensures real-time availability tracking and
            centralized financial management.
          </p>
        </div>

        {/* Features */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">
            Key Features
          </h2>

          <ul className="space-y-3 text-gray-400 list-disc ml-5">
            <li>Patient management and onboarding system</li>
            <li>Therapist profiles with availability tracking</li>
            <li>Session booking with intelligent scheduling logic</li>
            <li>Therapy package management and discount coupons</li>
            <li>Online payment integration using Razorpay</li>
            <li>Financial tracking comparing therapist income vs clinic revenue</li>
            <li>Role-based dashboards for admin and therapists</li>
          </ul>
        </div>

        {/* Results */}
        <div>
          <h2 className="text-2xl font-semibold text-white mb-4">
            Outcome
          </h2>

          <p className="text-gray-400 leading-relaxed">
            The system streamlined clinic operations and eliminated
            manual data entry across registers and spreadsheets.
            Receptionists could manage appointments more efficiently
            while clinic owners gained clear insights into therapy
            sessions, therapist performance, and financial tracking.
          </p>
        </div>

      </div>
    </section>
  );
};

export default TherapyClinicCaseStudy;